(function () {
  const initSlider = (swiperContainer) => {
    if (!swiperContainer || swiperContainer._swiperInstance) return;

    const mobileColumns = parseInt(swiperContainer.dataset.mobileColumns) || 1;

    swiperContainer._swiperInstance = new Swiper(swiperContainer, {
      loop: false,
      speed: 1100,
      slidesPerView: mobileColumns,
      spaceBetween: mobileColumns > 1 ? 16 : 0,
      navigation: {
        nextEl: swiperContainer.querySelector(".swiper-button-next"),
        prevEl: swiperContainer.querySelector(".swiper-button-prev"),
      },
    });
  };

  const destroySlider = (swiperContainer) => {
    if (!swiperContainer || !swiperContainer._swiperInstance) return;

    swiperContainer._swiperInstance.destroy(true, true);
    swiperContainer._swiperInstance = undefined;
  };

  const initMulticolumn = () => {
    document.querySelectorAll(".multicolumn-section").forEach((multicolumnSection) => {
      const swiperContainer = multicolumnSection.querySelector(".swiper--multicolumn");
      if (!swiperContainer) return;

      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;

        if (entry.contentRect.width < 990) {
          initSlider(swiperContainer);
        } else {
          destroySlider(swiperContainer);
        }
      });

      sectionResizeObserver.observe(multicolumnSection);
    });
  };

  initMulticolumn();

  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll(".swiper--multicolumn").forEach(destroySlider);
    initMulticolumn();
  });
})();
